<template>
  <el-dialog
    class="global-window"
    :title="title"
    status-icon
    :visible="visible"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="close"
  >
    <div v-if="visible" class="body">
      <slot />
    </div>
    <div v-if="show" slot="footer" class="window__footer">
      <el-button @click="close">取消</el-button>
      <el-button :loading="confirmWorking" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'GlobalWindow',
  props: {
    width: {
      type: String,
      default: '36%'
    },
    // 确认按钮loading状态
    confirmWorking: {
      type: Boolean,
      default: false
    },
    // 是否展示btn
    show: {
      type: Boolean,
      required: false
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // dialog显示与隐藏
    visible: {
      type: Boolean,
      required: true
    },
    display: {
      type: String,
      default: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
// 输入框高度
@input-height: 32px;
.global-window {
  // 头部
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #eee;
  }
  // 内容部分
  /deep/ .el-dialog__body {
    //margin-right: 30px;
    // 表单
    .el-form-item {
      margin-bottom: 18px;
      &:last-of-type {
        margin-bottom: 0;
      }
      .el-form-item__content > *{
        width: 100%;
      }
    }
  }
  // 尾部按钮
  .el-dialog__footer {
    .el-button {
      height: @input-height;
      width: 76px;
      padding: 0;
    }
  }
}
</style>
